import { useState, useCallback } from 'react';
import styled from "styled-components";
import { toast } from "react-toastify";
import fundo from "../../../styles/fundo.svg";


import logo from "../../../styles/imagem/Logomarca-06.png";
import { InputLogin } from './InputLogin';
import { InputSenha } from './InputSenha';

const FormWrapper = styled.div`
  width: 420px;
  background-image: url(${fundo});
  margin: auto;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 360px;
  }
`;

const FormContainer = styled.form`
  width: 100%;
  background-color: white;
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 0px 2px #ccc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h1`
  font-size: 30px;
  color: #575757;
  font-family: "Arial", sans-serif;
  text-align: center;
  margin: 10px 0;
`;

const Logo = styled.img`
  width: 200px;
  margin: 20px;
  
`;

const Card = styled.div`
  width: 100%;
  max-width: 320px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  margin-top: 15px;
  background-color: #a5adb0;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-image: url(${fundo});
  }
`;

const ForgotPassword = styled.button`
  font-size: 14px;
  color: #333;
  margin-top: 10px;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
`;

function Form({ urlApi }) {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const logEvento = useCallback(async (id, descricao) => {
    try {
      const logData = {
        COD_FUNCIONARIO: id,
        DESC_LOG: descricao,
      };

      await fetch(`${urlApi}logon/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(logData),
      });
    } catch (error) {
      console.error('Erro ao salvar log:', error);
    }
  }, [urlApi]);

  const handleLogin = async () => {
    if (!login || !senha) {
      toast.warn("Por favor, preencha todos os campos.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${urlApi}logon`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login: login.toLowerCase(), senha }),
      });

      const data = await response.json();
      const { token, id_usuario: id, login: userLogin } = data;

      if (response.ok) {
        localStorage.setItem('token', token);
        localStorage.setItem('id', id);
        localStorage.setItem('usuario', userLogin);
        toast.success(data.mensagem);

        await logEvento(id, 'Autenticação realizada com sucesso!');
        setTimeout(() => window.location.href = "/", 2000);
      } else {
        toast.error(data.error || 'Erro desconhecido no login.');
        await logEvento(id, `Falha no login: ${data.error || 'Erro desconhecido'}`);
      }
    } catch (err) {
      toast.error("Erro de conexão com o servidor.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleLogin();
    }
  };

  return (
    <FormWrapper>
      <Logo src={logo} alt="Logo" />

      <FormContainer onKeyDown={handleKeyDown}>
        <Title>Portal do Colaborador</Title>
        <Card>
          <InputLogin
            placeholder="Digite seu login"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
          />

          <InputSenha
            placeholder="Digite sua senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />

          <Button type="button" onClick={handleLogin} disabled={isSubmitting}>
            {isSubmitting ? "Entrando..." : "Entrar"}
          </Button>

          <ForgotPassword onClick={(e) => {
            e.preventDefault(); // impede que um formulário seja submetido ou link seja seguido
            window.location.href = "/esqueci-minha-senha";
          }}>
            Esqueci minha senha
          </ForgotPassword>

        </Card>
      </FormContainer>
    </FormWrapper>
  );
}

export default Form;
